(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Add this to your header.js file
  class SearchToggle {
    constructor() {
      this.searchButton = document.querySelector('search-button');
      this.searchContainer = document.querySelector('.header__search');
      this.searchCloseButton = document.querySelector('.header__search-close');
      this.searchInput = this.searchContainer?.querySelector('input[type="search"]');
      this.predictiveSearch = document.querySelector('predictive-search');
      this.isOpen = false;

      this.init();
    }

    init() {
      if (!this.searchButton || !this.searchContainer) return;

      // Bind events
      this.bindEvents();
    }

    bindEvents() {
      // Search button click
      this.searchButton.addEventListener('click', (e) => {
        e.preventDefault();
        // Only work on mobile
        if (window.innerWidth > 1023) return;

        this.toggleSearch();
      });

      // Close button click
      if (this.searchCloseButton) {
        this.searchCloseButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeSearch();
        });
      }

      // Escape key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.closeSearch();
        }
      });

      // Close on window resize to desktop
      window.addEventListener('resize', () => {
        if (window.innerWidth > 1023 && this.isOpen) {
          this.closeSearch();
        }
      });

      // Click outside to close
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.searchContainer.contains(e.target) && !this.searchButton.contains(e.target)) {
          this.closeSearch();
        }
      });

      // Prevent search container clicks from closing
      this.searchContainer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }

    toggleSearch() {
      if (this.isOpen) {
        this.closeSearch();
      } else {
        this.openSearch();
      }
    }

    openSearch() {
      // Only work on mobile
      if (window.innerWidth > 1023) return;

      this.isOpen = true;

      // Add classes for animation
      this.searchContainer.classList.add('search-active');
      this.searchButton.classList.add('active');

      // Focus the search input to trigger predictive search
      setTimeout(() => {
        if (this.searchInput) {
          this.searchInput.focus();

          // Trigger focus event to open predictive search
          this.searchInput.dispatchEvent(new Event('focus', { bubbles: true }));
        }
      }, 300);

      // Prevent body scroll on mobile
      document.body.style.overflow = 'hidden';
    }

    closeSearch() {
      this.isOpen = false;

      // Remove classes for animation
      this.searchContainer.classList.remove('search-active');
      this.searchButton.classList.remove('active');

      // Blur input and close predictive search
      if (this.searchInput) {
        this.searchInput.blur();
      }

      // Close predictive search more safely
      if (this.predictiveSearch) {
        try {
          // Remove predictive search classes
          this.predictiveSearch.classList.remove('predictive-search-open');
          document.body.classList.remove('search-open');

          // Hide search content if it exists
          const searchContent = this.predictiveSearch.querySelector('.search__content');
          if (searchContent) {
            searchContent.classList.add('hidden');
          }
        } catch (error) {
          console.log('Error closing predictive search:', error);
        }
      }

      // Restore body scroll
      document.body.style.overflow = '';
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new SearchToggle();
  });

  // Also handle if this script loads after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new SearchToggle();
    });
  } else {
    new SearchToggle();
  }

  } catch(e) { console.error(e); }
})();
})();
